module.exports = __webpack_public_path__ + "static/img/swipe-4.ae4c08b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/phoneHomePage/swipe-4.png
// module id = tH6j
// module chunks = 0